// 網站路徑判斷
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setWeb1Url, setMemberUrl } from '@/slices/urlSlice';

const WebUrl = () => {
    const dispatch = useDispatch();

    // 路徑判斷
    const handelUrl = () => {
        if (typeof window !== 'undefined') {
            const origin = window.location.href;
            if (origin.includes('localhost') || origin.includes('local.dev')) {
                dispatch(setWeb1Url('http://snv-web01.local.dev:4403'));
                dispatch(setMemberUrl('https://snv-member.local.dev:4406'));
            } else if (origin.includes('pubgame')) {
                dispatch(setWeb1Url('https://snv-web01.pubgame.tw'));
                dispatch(setMemberUrl('https://snv-member.pubgame.tw'));
            } else {
                dispatch(setWeb1Url('https://sounova.com'));
                dispatch(setMemberUrl('https://member.sounova.com'));
            }
        }
    };

    useEffect(() => {
        handelUrl();
    }, []);

    return null;
};

export default WebUrl;
